module.exports = __webpack_public_path__ + "b67383174f3ab7b17db4223f1dae4d12.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/4_column_large_x1_variable/public/news/temp.jpg
// module id = 369
// module chunks = 0